// Meta Pixel — lazy-loaded so it only runs on public marketing pages
// (landing / login / register) and never inside the authenticated app.
//
// Usage:
//   import { loadMetaPixel, trackPixel } from "../utils/metaPixel";
//   useEffect(() => { loadMetaPixel(); }, []);
//   trackPixel("Lead");                                         // simple
//   trackPixel("CompleteRegistration", { value: 0, currency: "USD" });
//
// `loadMetaPixel()` is idempotent — calling it more than once is safe;
// the script tag is only injected the first time, and PageView is fired
// once per browser session, not per call.

const PIXEL_ID = "941990648659684";
const SESSION_KEY = "fbq_pageview_fired";

let scriptLoaded = false;

export function loadMetaPixel() {
  if (typeof window === "undefined") return;
  if (window.fbq) return;            // already loaded by a previous mount
  if (scriptLoaded) return;
  scriptLoaded = true;

  // Standard Meta Pixel installation (verbatim from Events Manager)
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);

  // Fire PageView only once per browser session so SPA route changes
  // between landing → login → register don't inflate page views.
  try {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      window.fbq("track", "PageView");
      sessionStorage.setItem(SESSION_KEY, "1");
    }
  } catch {
    window.fbq("track", "PageView");
  }
}

export function trackPixel(eventName, params) {
  if (typeof window === "undefined" || !window.fbq) return;
  if (params && Object.keys(params).length > 0) {
    window.fbq("track", eventName, params);
  } else {
    window.fbq("track", eventName);
  }
}
